import { OrdersDataType } from "@/app/shared/ecommerce/dashboard/recent-order";
import { ordersColumns } from "@/app/shared/ecommerce/order/order-list/columns";
import Table from "@/components/table";
import { CustomExpandedComponent } from "@/components/table/custom/expanded-row";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TablePagination from "@/components/table/pagination";
import { orderData } from "@/data/order-data";
import { TableVariantProps } from "rizzui";
import Filters from "./filters";

export default function OrderTable({
    className,
    variant = "modern",
    hideFilters = false,
    hidePagination = false,
}: {
    className?: string;
    hideFilters?: boolean;
    hidePagination?: boolean;
    variant?: TableVariantProps;
}) {
    const { table, setData } = useTanStackTable<OrdersDataType>({
        tableData: orderData,
        columnConfig: ordersColumns(),
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 10,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
            },
            enableColumnResizing: false,
        },
    });

    return (
        <div className={className}>
            {!hideFilters && <Filters table={table} />}
            <Table
                table={table}
                variant={variant}
                classNames={{
                    container: "border border-muted rounded-md border-t-0",
                    rowClassName: "last:border-0",
                }}
                components={{
                    expandedComponent: CustomExpandedComponent,
                }}
            />
            {!hidePagination && (
                <TablePagination table={table} className="py-4" />
            )}
        </div>
    );
}
